import { render } from "./viewer.vue?vue&type=template&id=d9ad0484&scoped=true"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"

import "./viewer.vue?vue&type=style&index=0&id=d9ad0484&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ad0484"],['__file',"Scripts/components/pdf_viewer/viewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9ad0484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9ad0484', __exports__)) {
    api.reload('d9ad0484', __exports__)
  }
  
  module.hot.accept("./viewer.vue?vue&type=template&id=d9ad0484&scoped=true", () => {
    api.rerender('d9ad0484', render)
  })

}


export default __exports__